<template>
  <div class="flex flex-col items-center justify-center min-h-[60vh] w-full">
    <div class="flex flex-col items-center gap-6 w-full max-w-md">
      <div class="flex items-center gap-2">
        <i class="ri-links-line text-2xl text-[#248726]"></i>
        <h2 class="text-2xl font-semibold text-gray-900">Reset password link has expired</h2>
      </div>
      <p class="text-gray-700 text-base text-center">
        For security reasons, password reset links expire after a little while. Get a new link by trying reset password again.
      </p>
      <BaseButton size="custom"
        type="button"
        class="!bg-[#7a2323] text-base h-11 w-full !rounded max-w-sm"
        @click="proceedToLogin"
      >
        Return To Reset Password
      </BaseButton>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/atoms/buttons/BaseButton.vue';

function proceedToLogin() {
  window.location.href = "/";
}
</script>

<style scoped>
.text-white {
  color: #fff;
}
</style>
